import { css, tooltipClasses } from '@mui/material';

import type { ThemeOptions } from '@mui/material';
import type { TooltipProps } from './types';

export const tooltipThemes: ThemeOptions['components'] = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ ownerState, theme }) => {
        const { arrow, color } = ownerState as unknown as TooltipProps;
        const margin = !arrow ? 4 : 10;

        return css`
          background-color: ${color === 'default'
            ? theme.color['surface/transparent/strongest/default']
            : '#FFFFFFE5'};
          color: ${color === 'default'
            ? theme.color['text/inverse/default']
            : theme.color['text/default']};
          border-radius: 2;
          padding: 0;
          max-width: 304px;
          .${tooltipClasses.popper}[data-popper-placement*="top"] & {
            margin-bottom: ${margin}px;
          }
          .${tooltipClasses.popper}[data-popper-placement*="bottom"] & {
            margin-top: ${margin}px;
          }
          .${tooltipClasses.popper}[data-popper-placement*="left"] & {
            margin-right: ${margin}px;
          }
          .${tooltipClasses.popper}[data-popper-placement*="right"] & {
            margin-left: ${margin}px;
          }

          a {
            color: ${color === 'default'
              ? theme.color['text/interactive/inverse/default']
              : theme.color['text/interactive/default']};
          }
        `;
      },
      popper: () => css`
        white-space: pre-wrap;
      `,
      arrow: ({ ownerState, theme }) => {
        const { color } = ownerState as unknown as TooltipProps;
        return css`
          color: ${color === 'default'
            ? theme.color['surface/transparent/strongest/default']
            : '#FFFFFFE5'};
        `;
      },
    },
  },
};
